import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SellerFilterBody = _resolveComponent("SellerFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "sellers",
    ref: "sellerFilterItem",
    icon: "StrokedCartIcon",
    title: $options.getSellerTitle,
    selectedTitle: $options.getSellerSelectedTitle,
    selectedCount: $props.sellers?.selected?.length,
    no_reset: $props.no_reset,
    onClearAll: $options.onClear,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_SellerFilterBody, {
      title: "Seller",
      selected: $props.sellers?.selected,
      isModified: $props.sellers.isModified,
      pendingChanges: $props.sellers.pendingChanges,
      isSearching: $props.sellers.isSearching,
      keyword: $props.sellers.keyword,
      list: $props.sellers.displayList,
      no_reset: $props.no_reset,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.onSelect,
      onSelectOnly: $options.onSelectOnly,
      onDeselect: $options.onDeSelect,
      onApply: $options.onApply,
      onSearch: $options.onSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: $options.onClose
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "no_reset", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "no_reset", "onClearAll", "onApply", "onHidden"]);
}